const schema = (executionFlowTypes, parameters) => {
  let s = {
    type: "object",
    properties: {
      executionFlowTypeId: {
        type: "string",
        oneOf: executionFlowTypes.map((r) => ({
          const: r.id,
          title: r.name,
        })),
      },
      comments: {
        type: "string",
      },
    },
    required: ["executionFlowTypeId"],
  };

  if (parameters) {
    Object.keys(parameters.properties).forEach(
      (key) => (s.properties[key] = parameters.properties[key])
    );
    parameters?.required.forEach((key) => s.required.push(key));
  }

  return s;
};

export default schema;
